import {Component, EventEmitter, Inject, Output} from 'ng-metadata/core';
import { MediaQueries } from '../../../infra/mediaQueries.service';
import { MappingTablesCache } from '../../../mappingTablesCache/mappingTablesCache.service';
import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import {getVid} from "../../../appConfig/appConfigForward";
import { AuthoritySearchBarService } from './authoritySearchBar.service';
import { ChangeLangService } from '../../../infra/lang/changeLang.service';
import {AuthoritySearchService} from "../authoritySearch.service";


var angular: angular.IAngularStatic = require('angular');

@Component({
    'selector': 'prm-authority-search-bar',
    templateUrl: 'components/search/authority/authoritySearchBar/authority-search-bar.html',
})


export class PrmAuthoritySearchBar {
    public searchState = STATE_NAMES.AUTHORITY_SEARCH;
    private focusOnSearchInput: boolean = false;
    private vid = getVid();


    constructor(@Inject('$state') private $state: ng.ui.IStateService,
                @Inject('searchBoxIcons') private searchBoxIcons: Object[],
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$element') private $element,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                private mediaQueries: MediaQueries,
                private mtCache:MappingTablesCache,
                private authoritySearchBarService: AuthoritySearchBarService,
                private authoritySearchService: AuthoritySearchService,
                private changeLangService: ChangeLangService) {

        this.focusOnSearchInput = (this.mtCache.getTable(this.mtCache.tables.VIEW_PROPERTIES).filter((row) => row.source1 === this.vid && row.source2 === 'focus_on_search_input' && row.target === 'true').length === 1);

    }

    ngOnInit() {
        this.$scope.$watch(() => this.searchBarInput, (newVal, oldVal) => {
            this.$timeout(() => {
                this.removeAriaLabel('md-input-container input');
            }, 400);
        });
        if(this.$state.params["searchField"]){
            this.selectedScope = this.$state.params["searchField"];
        }
        else{
            if (this.selectedScope === undefined) {
                this.selectedScope = this.authoritySearchBarService.SEARCH_FIELD_SCOPES[0];
            }
        }

        // Initialize search operator from URL param or default to first enabled
        const defaultOperator = this.authoritySearchBarService.SEARCH_OPERATOR_OPTIONS.length > 0
            ? this.authoritySearchBarService.SEARCH_OPERATOR_OPTIONS[0].code
            : undefined;
        const searchOperatorParam = this.$state.params["searchOperator"];
        const isValidSearchOperator = !!searchOperatorParam &&
            this.authoritySearchBarService.SEARCH_OPERATOR_OPTIONS.some((option) => option.code === searchOperatorParam);

        if (isValidSearchOperator) {
            this.selectedOperator = searchOperatorParam;
        } else if (defaultOperator !== undefined) {
            this.selectedOperator = defaultOperator;
        }
        // Set autofocus to input search bar
        this.$timeout(() => {
            if (this.mediaQueries.gtmd && this.focusOnSearchInput) {
                let elem = document.querySelector('#searchBarAuthority');
                if (elem) {
                    elem.focus();
                }
            }
        }, 0);
    }

    public performSearch() {
         this.$state.go(this.searchState, {
            vid: getVid(), 
            authorityQuery: this.searchBarInput, 
            searchField: this.selectedScope,
            sort: this.authoritySearchService.getSearchObject().sortby,
            offset: 0,
            searchOperator: this.selectedOperator
            }, {reload: false});

        // Only for mobile -  This for auto-closing of the keyboard when the user clicks search from the mobile keyboard button
        if (!this.mediaQueries.gtmd) {
            document.getElementById("searchBar").blur();
        }
    }

    get searchBarInput(): string {
        return this.authoritySearchBarService.searchBarInput;
    }

    set searchBarInput(newSearchInput: string) {
        this.authoritySearchBarService.searchBarInput = newSearchInput;
    }

    private switchToLtrString() {
        return this.changeLangService.direction == 'rtl';
    }

    //this function remove aria-label from search edit field.
    private removeAriaLabel(str) {
        let searchEditField: [Element] = this.$element[0].querySelectorAll(str);
        for (let input of searchEditField) {
            input.removeAttribute('aria-label');
        }
    }

    private onClearSearchInput() {
        this.searchBarInput = undefined;
        document.querySelector('#searchBarAuthority').focus();
    }

    get selectedScope() {
        return this.authoritySearchBarService.selectedScope;
    }

    set selectedScope(newScope) {
        this.authoritySearchBarService.selectedScope = newScope;
    }

    get scopes() {
        return this.authoritySearchBarService.SEARCH_FIELD_SCOPES;
    }

    get selectedOperator(): string {
        return this.authoritySearchBarService.selectedOperator;
    }

    set selectedOperator(newOperator: string) {
        this.authoritySearchBarService.selectedOperator = newOperator;
    }

    get operatorOptions() {
        return this.authoritySearchBarService.SEARCH_OPERATOR_OPTIONS;
    }

    get hasMultipleOperators(): boolean {
        return this.authoritySearchBarService.hasMultipleOperators;
    }

}




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/authority/authoritySearchBar/authoritySearchBar.directive.ts